<div class="view-component">
    <div class="view-component-title">
        <span class="title">Fluxo de Integração</span>
    </div>

    <div class="maindiv">
        <!--simple-datagrid entityName='Mktpcfg' parentRow="" [selectedRow]="selectedRowCfg" [nodata]="true" [componentedit]="criacaoConfiguaracao" [condition]="condition" [customFields]="customFields"[callbackFunction]="callbackFunction" ></simple-datagrid-->
        <simple-datagrid entityName='Mktpcfg' parentRow="" [selectedRow]="selectedRowCfg" [nodata]="true" [componentedit]="criacaoConfiguaracao" [condition]="condition"  ></simple-datagrid>
    </div>

    <div class="maindiv">
        <simple-datagrid #dataGridLgt entityName='Mktplgt' parentRow="" [nodata]="true" [condition]="conditionLGT" [getCondition]="getConditionLGTFunction" ></simple-datagrid>
    </div>
    
</div>